import { render, staticRenderFns } from "./LBarrage.vue?vue&type=template&id=03e68f5e&scoped=true&"
import script from "./LBarrage.vue?vue&type=script&lang=js&"
export * from "./LBarrage.vue?vue&type=script&lang=js&"
import style0 from "./LBarrage.vue?vue&type=style&index=0&id=03e68f5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e68f5e",
  null
  
)

export default component.exports